<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrightt"><a id="page_iv"></a>A F<span class="small">EIWEL AND</span> F<span class="small">RIENDS</span> B<span class="small">OOK</span><br/>An Imprint of Macmillan</p>
<p class="copyright"><span class="small">EYES ON THE GOAL</span>. Copyright © 2010 by John Coy.<br/>All rights reserved. Distributed in Canada by H.B. Fenn and Company, Ltd.<br/>Printed in March 2010 in the United States of America<br/>by R. R. Donnelley &amp; Sons Company, Harrisonburg, Pennsylvania.<br/>For information, address Feiwel and Friends, 175 Fifth Avenue,<br/>New York, N.Y. 10010.</p>
<p class="copyright">Coy, John,<br/>Eyes on the goal / John Coy. — 1st ed.<br/>p. cm.<br/>Summary: Middle-schooler Jackson’s baseball skills are not of much help<br/>when he and his friends go to soccer camp, and while there he learns that his<br/>mother’s boyfriend has invited them to move into his house, and friend<br/>Gig’s father is deployed to Afghanistan.<br/>ISBN: 978-0-312-37330-6<br/>[1. Soccer—Fiction. 2. Camps—Fiction. 3. Ability—Fiction.<br/>4. Friendship—Fiction. 5. Soldiers—Fiction. 6. Family life—Fiction.]<br/>I. Title.<br/>PZ7.C839455Eye 2010<br/>[Fic]—dc22<br/>2009045387</p>
<p class="copyright">Book design by Tim Hall</p>
<p class="copyright">Feiwel and Friends logo designed by Filomena Tuosto</p>
<p class="copyright">First Edition: 2010</p>
<p class="copyright">10  9  8  7  6  5  4  3  2  1</p>
<p class="copyright"><span class="weblink"><a class="nounder" href="http://www.feiwelandfriends.com" target="_blank">www.feiwelandfriends.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?06335086